export const RATE_LIMIT_MESSAGE = '请求过于频繁，请稍后重试，未提交的内容会保留'

const cooldowns = new Map()
let lastNotice = -Infinity

function key(config) {
    const url = new URL(config.url, window.location.origin)
    const headers = config.headers || {}
    return url.origin + ':' + (headers.Authorization || headers.authorization || '')
}

export function remainingCooldown(config) {
    const identity = key(config)
    const remaining = Math.ceil(((cooldowns.get(identity) || 0) - Date.now()) / 1000)
    if (remaining > 0) return remaining
    cooldowns.delete(identity)
    return 0
}

export function recordRateLimit(config, headers = {}) {
    const retry = headers['retry-after']
    const seconds = retry !== undefined && retry !== null && retry !== '' && Number.isFinite(Number(retry))
        ? Number(retry) : (Date.parse(retry) - Date.now()) / 1000
    const until = Date.now() + (Number.isFinite(seconds) ? Math.max(1, seconds) : 60) * 1000
    const identity = key(config)
    cooldowns.set(identity, Math.max(cooldowns.get(identity) || 0, until))
}

export function cooldownError(config) {
    const remaining = remainingCooldown(config)
    if (!remaining) return null
    const error = new Error(RATE_LIMIT_MESSAGE)
    error.config = config
    error.rateLimited = true
    error.localCooldown = true
    error.response = { status: 429, data: { msg: RATE_LIMIT_MESSAGE }, headers: { 'retry-after': String(remaining) } }
    return error
}

export function shouldNotifyRateLimit() {
    if (Date.now() - lastNotice < 10000) return false
    lastNotice = Date.now()
    return true
}
